module.exports = __webpack_public_path__ + "img/phone.b01c1068.png";